//CRN_20260407 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ApplicationNames, OurCompany } from 'src/app/core/consts';
import { BehaviorSubject } from 'rxjs';
import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export type PlatformInviewMode='inview' | 'mdm' | 'platform' | 'suresim';

@Injectable({ providedIn: 'root' })

export class PlatformInviewService {

  private isPlatformMode      : boolean=environment.platformMode;
  private isPlatformModeInview: boolean=environment.platformModeInview;
  private mode$               : BehaviorSubject<PlatformInviewMode>=new BehaviorSubject<PlatformInviewMode>('platform');

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public getApplicationTitle(): string {
    try {
      return this.isPlatformMode || this.isPlatformModeInview
             ? ApplicationNames.ApplicationTitle_Platform
             : ApplicationNames.ApplicationTitle_SureSimPortal;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'platform';
    }
  }

  public getMode(): PlatformInviewMode {
    try {
      return this.mode$.value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'platform';
    }
  }

  public getOurCompanyName(): string {
    try {
      return this.isPlatformMode || this.isPlatformModeInview
             ? OurCompany.CompanyNamePlatform
             : OurCompany.CompanyNamePascal;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'platform';
    }
  }

  public mode(): BehaviorSubject<PlatformInviewMode> {
    try {
      return this.mode$;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.mode$;
    }
  }

  public setMode(mode: PlatformInviewMode): void {
    try {
      this.mode$.next(mode);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
